import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LogOut, Mail } from 'lucide-react';
import { formatDateNL } from '../lib/billingDates';

export function SubscriptionEnded() {
  const { activeCancellation, signOut, user } = useAuth();

  const endDate = activeCancellation?.effective_end_date;

  return (
    <div className="min-h-screen bg-[#F2F2EF] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl border border-gray-200 p-8 text-center">
        <h1 className="text-2xl font-bold text-[#231F20] mb-3">
          Je dibbi-abonnement is afgelopen
        </h1>
        {endDate && (
          <p className="text-gray-600 mb-6">
            Je toegang stopte op <strong>{formatDateNL(endDate)}</strong>. Bedankt dat je dibbi
            hebt gebruikt{user?.first_name ? `, ${user.first_name}` : ''}.
          </p>
        )}

        <div className="bg-[#F2F2EF] rounded-xl p-5 mb-6 text-left">
          <p className="text-sm text-gray-700 mb-3">
            Wil je terugkeren? Mail ons en we activeren je account opnieuw.
          </p>
          <a
            href="mailto:admin@dibbi.nl?subject=Heractiveer mijn dibbi-abonnement"
            className="btn-primary inline-flex items-center gap-2"
          >
            <Mail className="w-4 h-4" />
            Mail admin@dibbi.nl
          </a>
        </div>

        <button
          onClick={signOut}
          className="text-sm text-gray-500 hover:text-gray-700 inline-flex items-center gap-1.5"
        >
          <LogOut className="w-4 h-4" />
          Uitloggen
        </button>
      </div>
    </div>
  );
}
